$(document).ready(function(){
    'use strict'

    //Работа селекта
    $('.cell-select__header').on('click', function () {
        $(this).parents('.cell-select').find('.cell-select__body').slideToggle();
        $(this).parents('.cell-select').toggleClass('is-active');
    })

    $('.cell-select__body').on('click', '.cell-select__item', function () {
        let text = $(this).text().trim();
        const cellSelectBlock = $(this).parents('.cell-select')
        const cellBlock = $(this).parents('.cell')

        cellSelectBlock.find('.cell-select__item').removeClass('cell-select__item--selected');
        cellSelectBlock.find('.cell-select__body').slideToggle();
        cellSelectBlock.find('.cell-select__current').text(text);
        cellSelectBlock.find('.cell-select__input').val(text);
        $(this).addClass('cell-select__item--selected');
        cellSelectBlock.toggleClass('is-active');
        cellBlock.removeClass('cell--error')
        cellBlock.find('.cell__error-message').slideUp();
    });
});
